// src/v3/logos/mati.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx, jsxs } from "react/jsx-runtime";
var MatiLogo = (props) => /* @__PURE__ */ jsxs(SvgIcon, { "data-testid": "MatiLogo", viewBox: "0 0 32 32", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M21.5462 26.6964C20.8215 26.7232 20.2154 27.2668 20.0029 27.5352H22.7876C23.0337 26.7076 23.6331 24.7303 24.0626 23.4419C23.4989 22.7978 23.3133 20.9368 23.2909 20.0868C23.2909 17.8322 24.9237 16.6199 25.7401 16.2956C26.1539 15.3561 26.8473 13.1418 26.3105 11.7997C24.7336 7.94134 20.547 8.41106 18.232 8.67946C16.7222 18.0738 19.3056 19.9191 20.741 21.3282C22.2844 23.0119 21.8482 25.9918 21.5462 26.6964Z",
      fill: "#A6CE3A"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.4481 26.6628C5.42815 26.636 4.94948 27.2332 4.83765 27.5352H7.65594C8.0921 26.7188 9.15903 24.6565 9.93741 22.9387C9.56835 20.0868 6.98492 18.4093 6.4481 18.3757C7.55528 21.8315 7.25332 24.5491 6.4481 26.6628Z",
      fill: "#FA9F1C"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20.8241 8.51192L20.8153 8.51171C20.1174 8.48078 18.8022 8.61238 18.2318 8.67949C17.9187 10.0215 17.7548 13.5041 19.3653 16.564C21.3783 20.3888 25.9413 21.4624 28.9609 21.9322C27.7866 20.3553 27.4511 17.6376 27.2162 13.1418C26.9818 8.65504 22.2771 8.54569 20.8241 8.51192Z",
      fill: "#FEB913"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M15.2384 9.21629C12.8563 9.21629 12.0511 8.78012 11.0781 8.27686C11.0781 8.43343 11.0043 8.80696 10.709 9.04853C6.17963 10.0215 5.97832 14.7522 6.48159 18.3086C10.4742 20.3217 10.34 24.9182 9.87025 26.9984C9.19923 27.052 8.69596 27.6917 8.5282 28.0049H10.709C11.4471 28.0049 12.3866 21.5295 12.7892 18.8454C15.749 18.5611 19.2047 18.9301 20.2784 14.4678C20.6633 12.8681 19.7416 9.08208 18.2318 8.67947C17.1839 8.89804 16.2083 9.21629 15.2384 9.21629Z",
      fill: "#F0537E"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M10.709 9.04853C6.17963 10.0215 5.97832 14.7522 6.48159 18.3086C8.57535 19.3643 9.5342 21.1304 9.90493 22.8716L11.38 18.8454H12.7556L13.9635 9.16504C12.521 9.03568 11.8527 8.67753 11.0781 8.27686C11.0781 8.43343 11.0043 8.80696 10.709 9.04853Z",
      fill: "#DE1F26"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.1121 4.01596C10.8101 3.88656 9.90423 4.57515 9.53517 4.95539V4.01596C1.38225 5.69352 1.44936 13.3767 6.48202 18.3087C6.61623 13.1754 8.93125 11.7327 11.3134 12.236C13.2191 12.6386 13.7626 11.5761 13.7962 10.9946C13.0021 10.5249 11.3939 9.47136 11.3134 9.01507C11.2127 8.4447 10.6424 7.13621 10.2062 6.56584C11.0114 5.59286 11.3134 4.10223 11.1121 4.01596Z",
      fill: "#00B0EC"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25.572 16.8326C25.9411 15.6248 28.0883 10.9948 23.8609 9.2165C21.8143 8.35559 21.0164 8.3777 18.2316 8.67966C17.4935 12.5716 18.8097 15.5415 19.3388 16.5306C20.1018 17.957 20.5696 18.3667 23.1347 20.6133L23.2234 20.691C25.3663 22.5677 24.7668 25.5894 24.1629 27.1999C23.4919 27.1999 23.011 27.7367 22.8544 28.0051H25.9411C26.1312 27.1551 26.6054 24.9721 26.9812 23.0395C25.3439 20.597 25.3595 17.8839 25.572 16.8326Z",
      fill: "#00A664"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.88354 5.02255L10.6888 4.51929C10.6888 4.59981 10.398 5.11202 10.2526 5.35806L9.88354 5.02255Z",
      fill: "#00A8E7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.91735 6.6665C6.45041 7.51646 0.892111 11.0214 6.39449 18.2416C6.22673 14.3833 5.18665 10.4913 9.91735 6.6665Z",
      fill: "#00A8E7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M9.17924 4.28442C8.66927 4.41863 7.82602 5.39161 7.46814 5.86132C7.54643 5.92843 7.8372 5.99553 8.37402 5.72712C9.04504 5.39161 9.14569 4.68704 9.17924 4.28442Z",
      fill: "#00A8E7"
    }
  )
] });

export {
  MatiLogo
};
